"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseReceiveTasks = void 0;
const index_1 = require("../../../../../Errors/index");
const index_2 = require("../../../../Model/index");
const TypeFactory_1 = require("../../../TypeFactory");
const ActivityFactory_1 = require("./ActivityFactory");
function parseReceiveTasks(processData, eventDefinitions) {
    const receiveTasksRaw = (0, TypeFactory_1.getModelPropertyAsArray)(processData, index_2.BpmnTags.TaskElement.ReceiveTask);
    const noReceiveTasksFound = !((receiveTasksRaw === null || receiveTasksRaw === void 0 ? void 0 : receiveTasksRaw.length) > 0);
    if (noReceiveTasksFound) {
        return [];
    }
    const receiveTasks = receiveTasksRaw.map((receiveTaskRaw) => {
        const flowNodeId = receiveTaskRaw.id;
        try {
            return parseReceiveTask(receiveTaskRaw, eventDefinitions);
        }
        catch (error) {
            error.additionalInformation = {
                ...error.additionalInformation,
                flowNodeId: flowNodeId,
            };
            throw error;
        }
    });
    return receiveTasks;
}
exports.parseReceiveTasks = parseReceiveTasks;
function parseReceiveTask(receiveTaskRaw, eventDefinitions) {
    const receiveTask = (0, ActivityFactory_1.createActivityInstance)(receiveTaskRaw, index_2.Model.Activities.ReceiveTask);
    if (!receiveTaskRaw.messageRef) {
        throw new index_1.UnprocessableEntityError(`ReceiveTask \`${receiveTaskRaw.id}\` does not have a messageRef!`);
    }
    receiveTask.messageEventDefinition = eventDefinitions.find((entry) => entry.id === receiveTaskRaw.messageRef);
    return receiveTask;
}
//# sourceMappingURL=ReceiveTaskParser.js.map